import React, { useEffect } from "react";
import useLenis from "../lib/useLenis";
import { captureAttribution } from "../lib/utmTracking";
import { initAnalytics } from "../lib/analytics";
import SEO from "../components/SEO";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Services from "../components/Services";
import Showreel from "../components/Showreel";
import Portfolio from "../components/Portfolio";
import About from "../components/About";
import Process from "../components/Process";
import Contact from "../components/Contact";
import Brief from "../components/Brief";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import ScrollProgress from "../components/ScrollProgress";
import CookieBanner from "../components/CookieBanner";

export default function Home() {
    useLenis();
    useEffect(() => {
        // Capture UTM / referrer / gclid / fbclid on landing (first-touch + last-touch)
        captureAttribution();
        // Boot the homegrown analytics tracker (respects consent internally)
        initAnalytics();
    }, []);
    return (
        <main data-testid="home-page" className="bg-scd text-cream">
            <SEO
                title="Studio créatif à Magog"
                description="Studio Cent Douze — studio créatif à Magog. Création de sites web, photo, vidéo, création de contenu et identité de marque pour les PME du Québec et de l'Estrie."
                path="/"
                ogSlug="home"
            />
            <ScrollProgress />
            <Header />
            <Hero />
            <Marquee />
            <Services />
            <Portfolio />
            <Showreel />
            <About />
            <Process />
            <FAQ />
            <Brief />
            <Footer />
            <CookieBanner />
        </main>
    );
}
